import type { APIEnv } from '../../types/base'

export const API_URL: Record<APIEnv, string> = {
  local: 'https://dev-ai-api.betteryeah.com',
  development: 'https://dev-ai-api.betteryeah.com',
  pre: 'https://pre-ai-api.betteryeah.com',
  production: 'https://ai-api.betteryeah.com',
}